const page = (title = '', type) => {
    if (window && window.dataLayer) {
        window.dataLayer.push({
            event: 'page_load',
            page_hostname: window.location.hostname,
            page_title: title,
            page_type: type
        });
    }
};

const event = (event_name, data = {}) => {
    if (window && window.dataLayer) {
        window.dataLayer.push({
            event: event_name,
            ...data
        });
    }
};

export default {
    page,
    event
};



// WEBPACK FOOTER //
// ./src/utils/gtmUtils.js